import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './components/Common/ToolBarSearch.scss';
import React from 'react';
import { ReduxRouter, createRouterMiddleware, createRouterReducerMapObject } from '@lagunovsky/redux-react-router';
import { configureStore } from '@reduxjs/toolkit'
import { registerLicense } from '@syncfusion/ej2-base';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Provider } from 'react-redux';
import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import App from 'App';
import { configurationService } from './subjects/ConfigurationService';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

ajax('api/Config/B2C')
    .pipe(map((response) => response.response))
    .subscribe((config) => {
        configurationService.set(config);
        registerLicense(config.syncfusionLicenseKey);

        const history = createBrowserHistory()
        const routerMiddleware = createRouterMiddleware(history)

        const store = configureStore({
        reducer: createRouterReducerMapObject(history),
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(routerMiddleware),
        })


        root.render(
            <Provider store={store}>
                <ReduxRouter history={history}>
                    <GoogleReCaptchaProvider reCaptchaKey={config.googleSiteKey}>
                        <App history={history} />
                    </GoogleReCaptchaProvider>
                </ReduxRouter>
            </Provider>
        );
    });
